import Flickity from 'flickity'

class Slider {
  constructor(slider) {
    this.slider = slider
    this.flkty = null;
    this.initSlider()
  }

  initSlider() {
    this.flkty = new Flickity(this.slider, {
      wrapAround: true,
      pageDots: true,
      prevNextButtons: true,
      autoPlay: this.slider.getAttribute('flickity-autoplay') == "1",
      setGallerySize: true,
      cellSelector: ".m-slide",
      arrowShape: "",
    });
  }

}

export default Slider
